import styled from "@emotion/styled";
import { Image } from "antd";
import { useNavigate } from "react-router-dom";
import { RightArrows } from "../../../common/component/RightArrows";

interface Props {
    src?: string;
    url?: string;
}

export const ProductImgCard = (props: Props) => {
    const navigate = useNavigate();

	return (
		<Container onClick={() => props.url && navigate(props.url)}>
			<Image src={props.src} preview={false} />
            <div className="line"><RightArrows /></div>
		</Container>
	);
};
const Container = styled.div`
	width: 100%;
    cursor: pointer;
    position: relative;

    .line {
        position: absolute;
        right: 0;
        bottom: 0;
        padding: 20px;
    }
`;
